import { superstyled } from '@zenbusiness/zui/styles';

export const Background = superstyled({
  name: 'AppHeaderBackground',
  slot: 'Background',
  styles: () => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: 0,
    zIndex: 10,
    backdropFilter: 'blur(32px)',
    background: `linear-gradient(90deg, #111112 0%, #1B2845 100%)`
  })
});

export const Root = superstyled({
  name: 'AppHeaderRoot',
  slot: 'Root',
  // tag: ZuiContainer,
  styles: ({ theme }) => ({
    maxWidth: '150rem',
    width: `calc(100vw - ${theme.spacing(4)})`,
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    gridTemplateRows: '1fr',
    justifyContent: 'space-between',
    paddingBlock: theme.spacing(1),
    gap: theme.spacing(2),
    color: theme.palette.text.white,
    [theme.breakpoints.up('sm')]: {
      paddingBlock: theme.spacing(2),
      width: `calc(100vw - ${theme.spacing(8)})`
    }
  })
});

export const LeftContainer = superstyled({
  name: 'AppHeaderLeftContainer',
  slot: 'LeftContainer',
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minWidth: '3.25rem', // match CloseButton width (approx)
    [theme.breakpoints.up('sm')]: {
      minWidth: '13rem' // match CloseIcon size in mobile
    }
  })
});

export const RightContainer = superstyled({
  name: 'AppHeaderRightContainer',
  slot: 'RightContainer',
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    minWidth: '3.25rem', // match CloseButton width (approx)
    [theme.breakpoints.up('sm')]: {
      minWidth: '13rem' // match CloseIcon size in mobile
    }
  })
});

export const Branding = superstyled({
  name: 'AppHeaderBranding',
  slot: 'Branding',
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    color: theme.palette.text.white, // 'rgba(255,255,255,0.93)',
    fontWeight: 600
  })
});

export const BrandingText = superstyled({
  name: 'AppHeaderBrandingText',
  slot: 'BrandingText',
  styles: () => ({
    fontWeight: 600,
    textAlign: 'center',
    whiteSpace: 'nowrap'
  })
});

export const Actions = superstyled({
  name: 'AppHeaderActions',
  slot: 'Actions',
  propsNeeded: ['fullWidth'],
  styles: ({ theme }) => ({
    gridArea: 'right-container',
    display: 'flex',
    alignItems: 'end',
    gap: theme.spacing(1),
    justifyContent: 'flex-end'
  })
});

export const Button = superstyled({
  name: 'AppHeaderButton',
  slot: 'Button',
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    size: 'sm',
    borderRadius: theme.shape.borderRadius,
    padding: '0.5rem 1rem',
    border: `1px solid rgba(255, 255, 255, 0.24)`,
    color: theme.palette.text.white, // 'rgba(255,255,255,0.93)',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.1)'
    },
    cursor: 'pointer'
  })
});

export const IconButton = superstyled({
  name: 'AppHeaderIconButton',
  slot: 'IconButton',
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    size: 'sm',
    borderRadius: theme.shape.borderRadius,
    padding: '0.5rem 1rem',
    border: `1px solid rgba(255, 255, 255, 0.24)`,
    color: theme.palette.text.white, // 'rgba(255,255,255,0.93)',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.1)'
    },
    cursor: 'pointer'
  })
});

export const LeftSpacer = superstyled({
  name: 'AppHeaderLeftSpacer',
  slot: 'LeftSpacer',
  styles: ({ theme }) => ({
    width: 'auto',
    minWidth: '3.25rem', // match CloseButton width (approx)
    [theme.breakpoints.up('sm')]: {
      minWidth: '13rem' // match CloseIcon size in mobile
    }
  })
});
